import { render, staticRenderFns } from "./EBITGesamtJahre.vue?vue&type=template&id=45672fcb&"
import script from "./EBITGesamtJahre.vue?vue&type=script&lang=ts&"
export * from "./EBITGesamtJahre.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports